import { useContext } from "react";
import { DataTablePreferencesContext } from "./dataTablePreferencesContext";
import type { UseTableColumnPreferencesResult } from "./useTableColumnPreferences";

export function useDataTablePreferences<T>() {
  const ctx = useContext(DataTablePreferencesContext);
  return ctx as UseTableColumnPreferencesResult<T> | null;
}
